import React, { useMemo } from 'react';
import { Player, GameConfig } from '../../domain/entities';
import { Modal } from '../shared/Modal';
import { calculateReleasePenalty } from '../../domain/constants';

interface ReleasePlayerModalProps {
    player: Player | null;
    onClose: () => void;
    onConfirm: () => void;
    isPlayerInLineup: boolean;
    weeksPerSeason?: number;
    leagueName?: string;
    gameType?: 'mens' | 'womens';
    gameConfig?: GameConfig;
}

export const ReleasePlayerModal: React.FC<ReleasePlayerModalProps> = ({
    player,
    onClose,
    onConfirm,
    isPlayerInLineup,
    weeksPerSeason = 60,
    leagueName = 'Premier League',
    gameType = 'mens',
    gameConfig
}) => {
    if (!player) return null;

    // Calculate release penalty based on market value (30% of player value)
    const releasePenalty = useMemo(() => {
        if (gameConfig) {
            return calculateReleasePenalty(player, leagueName, gameType, gameConfig);
        }
        return 0;
    }, [player, leagueName, gameType, gameConfig]);

    return (
        <Modal isOpen={!!player} onClose={onClose}>
            <h2>Release Player</h2>
            {isPlayerInLineup && (
                <p className="negative">Warning: {player.name} is in your starting lineup. Releasing them will leave a gap in your team.</p>
            )}
            <p>Are you sure you want to release {player.name}?</p>
            <p style={{ opacity: 0.8 }}>The player will become a free agent and other clubs can bid on them. A bidding deadline of 2 weeks will be set once the first bid arrives.</p>
            <p className="negative">Release penalty: <strong style={{color: 'var(--negative-color)'}}>£{releasePenalty.toLocaleString()}</strong> (30% of player market value)</p>
            <div className="modal-actions">
                <button className="button" onClick={onClose}>Cancel</button>
                <button className="button danger" onClick={onConfirm}>Release Player</button>
            </div>
        </Modal>
    );
};
